<div class="d-flex">
  <div class="col-md-5 col-7">
    <div class="marB15">
      <span class="listLeft">
        <span class="data-letters float-left marR6" name="candnameinitial" id="candidateInitial">{{
          profileData?.candidateName || 'NA' | initials
        }}</span>

        <span class="marginicon40" name="candname" style="margin-left: 60px; margin-top: -40px">
          <h5 name="candidateName" class="h5Header GreyDarkest padding1pxBottom" id="title-candidateName">
            {{ profileData?.candidateName || 'NA' | titlecase }}
          </h5>

          <h5 name="candidateId" class="h5Header GreyDarkest marT4 inline padding1pxBottom" id="title-candidateId">
            {{ candidateId }}
          </h5>

          <div class="inline padding1pxBottom d-flex">
            <img src="assets/images/icons/default_icons/icon-call.png" alt="icon-call" style="width: max-content" />
            <span class="mainBodyTxt4 GreyLight marT4" name="contactno" id="title-candidateContactNo">
              {{ profileData?.contactNo || 'NA' }}
            </span>
          </div>

          <div>
            <div class="inline padding1pxBottom">
              <img src="assets/images/icons/default_icons/icon-mail.png" alt="icon-mail" />
              <span class="mainBodyTxt4 GreyLight marT4" name="emailid" id="title-profileData">
                {{ profileData?.emailId || 'NA' }}
              </span>
            </div>
            <div class="inline padding1pxBottom">
              <img src="assets/images/icons/default_icons/icon-location.png" alt="icon-location" />
              <span class="mainBodyTxt4 GreyLight marT4" name="interviewloc" id="interviewLocation">
                {{ profileData?.interviewLocation || 'No Location' }}
              </span>
            </div>
          </div>
        </span>
      </span>
    </div>
  </div>
  <div *ngIf="!isSearch" class="col-md-3 col-4 offset-md-2 padL4Percent">
    <mat-form-field class="custom-form-field" *ngIf="!inOffer && !isRecruiter">
      <mat-select
        placeholder="{{ selectedStatusID ? 'Selected Status' : 'Select Status' }}"
        [(ngModel)]="selectedStatusID"
        (ngModelChange)="statusChange()"
      >
        <mat-option
          *ngFor="let status of allEventStatus; let index = index"
          [value]="status.statusId"
          id="status-index-{{ index }}"
        >
          {{ status.statusDescrption | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button
      name="viewJD"
      mat-stroked-button
      class="margin-button1"
      (click)="viewJD()"
      *ngIf="rolePass === 'Scheduler'"
      [ngStyle]="{ outline: '0' }"
      id="btn-candidateViewJD"
    >
      View JD
    </button>
    <button
      name="viewProfile"
      mat-stroked-button
      class="margin-button float-right"
      (click)="viewProfile(profileData)"
      [ngStyle]="{ outline: '0' }"
      id="btn-candidateViewProfile"
    >
      View Profile
    </button>
  </div>
  <div *ngIf="isSearch && ['11'].includes(companyHiringTypeId)" class="col-md-7 col-5" style="text-align: right">
    <div class="marT20">
      <button
        id="applnForm"
        mat-stroked-button
        class="margin-button mr6 marR8"
        *ngIf="checkApp"
        (click)="downloadApplication(applicationFormId)"
      >
        Application Form
      </button>
      <button name="resume" mat-stroked-button class="margin-button mr6 marR8" (click)="viewResume()">Resume</button>
      <button
        name="viewProfile"
        mat-stroked-button
        class="margin-button mr6"
        (click)="viewProfile(profileData)"
        [ngStyle]="{ outline: '0' }"
        id="btn-candidateViewProfile-search"
      >
        View Profile
      </button>
    </div>
  </div>
  @if (isSearch && !['11'].includes(companyHiringTypeId)) {
    <div class="col-md-7 col-5" style="text-align: right">
      <div class="marT20">
        <button mat-icon-button [matMenuTriggerFor]="menu" style="width: 56px; height: 56px; padding: 0">
          <mat-icon style="font-size: 36px; line-height: 36px; width: 36px; height: 36px">menu</mat-icon>
        </button>
        <div class="menu-container-1">
          <mat-menu #menu="matMenu" panelClass="first-menu" class="candidateprofilemenu">
            <ng-container *ngIf="companyHiringTypeId == '1'">
              <button mat-menu-item (click)="displayButton('Candidate Gallery')">Candidate Gallery</button>
            </ng-container>

            <ng-container *ngIf="applnStatus()">
              <button mat-menu-item (click)="displayButton('Background Verification Status')">
                Background Verification Status
              </button>
            </ng-container>

            <ng-container *ngIf="checkApp">
              <button mat-menu-item (click)="displayButton('Candidate Application Form')">
                Candidate Application Form
              </button>
            </ng-container>

            <ng-container *ngIf="HRApp">
              <button mat-menu-item (click)="displayButton('HR Application Form')">HR Application Form</button>
            </ng-container>

            <ng-container *ngIf="companyHiringTypeId == '1' && interviewDetailsDisp">
              <button mat-menu-item (click)="displayButton('Interview Details')">Interview Details</button>
            </ng-container>
            @if (roleCode === 'RECRUITER' || roleCode == 'DBAS') {
              <button mat-menu-item (click)="displayButton('Exile')">Edit/Erase Candidate Data</button>
            }
            <button mat-menu-item (click)="displayButton('Resume')">Resume</button>
            <button mat-menu-item (click)="displayButton('View Profile')">View Profile</button>
            <button
              mat-menu-item
              *ngIf="companyHiringTypeId == '1' && userRole() === 'Recruiter'"
              (click)="displayButton('Share')"
            >
              Share
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  }
</div>

<div class="d-flex">
  <div style="margin-left: 80px">
    <table aria-describedby="mydesc" style="width: 100%">
      <thead>
        <tr>
          <th id="label-exp">
            <h5 class="h5Header GreyDarkest padding1pxBottom marT8" name="itexperienceheading">
              <strong>IT Experience</strong>
            </h5>
          </th>
          <th id="label-company">
            <h5 class="h5Header GreyDarkest paddingLeft marT8" name="currentcompanyheading">
              <strong>Current Company</strong>
            </h5>
          </th>
          <span *ngIf="role()">
            <th id="label-Attachment">
              <h5 class="h5Header GreyDarkest paddingLeft marT8" name="Attachmentheading">
                <strong>Documents Uploaded</strong>
              </h5>
            </th>
          </span>
          <th id="label-skills">
            <h5 class="h5Header GreyDarkest paddingLeft marT8" name="skillheading"><strong>Skills</strong></h5>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <span class="mainBodyTxt4 GreyLight d-block marT4" name="itexperience" id="candidateITExp"
              >{{ profileData?.itExperience || 'NA' }}
            </span>
          </td>
          <td>
            <span
              class="mainBodyTxt4 GreyLight paddingLeft d-block marT4"
              name="currentemployer"
              id="candidateCurrentEmplyr"
            >
              {{ profileData?.currentEmployer || 'NA' | titlecase }}
            </span>
          </td>
          <span *ngIf="role()">
            <td>
              <app-semicircular-progressbar
                [percentage]="true"
                [match]="percentage"
                (click)="attachmentData()"
                [ngStyle]="{ cursor: 'pointer' }"
              >
              </app-semicircular-progressbar>
            </td>
          </span>
          <td>
            <span class="mainBodyTxt4 GreyLight paddingLeft d-block marT4" name="skillprofile" id="candidate-skill">
              {{ profileData?.skills || 'NA' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
